import type { ComponentProps } from 'react';
import { clsx } from 'clsx';
import styles from './Input.module.scss';

export type InputProps = ComponentProps<'input'> & {
  readonly label: string;
  readonly suffix?: string;
  readonly variant?: 'small' | 'medium';
};

const Input = ({ label, id, type = 'text', suffix, variant = 'medium', className, ...props }: InputProps) => {
  return (
    <div className={className}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      {!suffix && <input id={id} className={styles.input} type={type} {...props} />}
      {!!suffix && (
        <div className={styles.withSuffix}>
          <input
            id={id}
            className={clsx(styles.input, {
              [styles.small]: variant === 'small',
              [styles.medium]: variant === 'medium',
            })}
            type={type}
            {...props}
          />
          <span
            className={clsx(styles.suffix, {
              [styles.small]: variant === 'small',
              [styles.medium]: variant === 'medium',
            })}
          >
            {suffix}
          </span>
        </div>
      )}
    </div>
  );
};

export default Input;
